import { httpClient } from '@/Repositories/HttpClient';

export default {
    async getPermissions()
    {
        return httpClient.get(route('permissions.getPermissions'));
    }
}
